const label = "text-sm py-1 flex items-center font-semibold text-neutral-700";
const inputStyle = 'rounded-lg px-4 py-3 outline-none border border-neutral-300 bg-white w-full my-1 text-sm placeholder:text-neutral-400 focus:border-primary focus:ring-2 focus:ring-primary-light transition-all';

// Header/Title Standardization
const pageTitle = 'text-3xl font-bold text-primary';          // Main page headers (h1)
const sectionTitle = 'text-2xl font-bold text-primary';       // Section headers (h2)
const title = 'text-2xl font-bold text-primary';              // Compatibility
const subTitle = 'text-lg font-semibold text-primary py-2';   // Subtitle (h3)
const modalTitle = 'text-2xl font-bold text-primary text-center';

// Button Standardization - All use primary color and rounded-lg
const btnOne = 'w-full border border-primary rounded-lg py-3 px-6 text-center text-sm text-white bg-primary font-semibold cursor-pointer hover:bg-primary-dark transition-all duration-200 shadow-base'
const btnOneLight = 'flex items-center border border-primary rounded-lg p-2 px-4 text-center text-sm text-primary bg-primary-light font-medium cursor-pointer hover:bg-primary hover:text-white transition-all duration-200'
const btnTwo = 'w-full border border-primary rounded-lg p-3 text-center text-primary font-semibold cursor-pointer hover:bg-primary-light transition-all duration-200'
const btnSmallTwo = 'border border-primary rounded-lg py-2 px-6 text-center text-sm text-white bg-primary flex gap-2 items-center cursor-pointer hover:bg-primary-dark transition-all duration-200 shadow-base'
const btnCancel = 'w-full border border-neutral-300 rounded-lg p-3 px-6 text-center text-neutral-700 bg-white font-semibold cursor-pointer hover:bg-neutral-50 transition-all duration-200'
const btnSmall = 'border border-primary rounded-lg py-2 px-6 text-center text-sm text-white bg-primary font-semibold flex gap-2 items-center cursor-pointer hover:bg-primary-dark transition-all duration-200 shadow-base'
const btnRound = 'bg-neutral-100 hover:bg-neutral-200 rounded-full p-3 cursor-pointer transition-all duration-200'
const btnWhite ='w-full rounded-lg p-3 bg-white border border-neutral-300 text-sm flex items-center justify-center gap-2 cursor-pointer hover:bg-neutral-50 transition-all duration-200'
const btnRed = 'bg-danger py-2 px-4 rounded-lg text-xs text-white mr-4 cursor-pointer hover:bg-danger-light transition-all duration-200 shadow-base'
const btnGreen = 'bg-primary py-2 px-4 rounded-lg text-xs text-white mr-4 cursor-pointer hover:bg-primary-dark transition-all duration-200 shadow-base'
const btnOneNoWidth = 'border border-primary rounded-lg py-3 px-6 text-center text-sm text-white bg-primary font-semibold cursor-pointer hover:bg-primary-dark transition-all duration-200'
// Action buttons - Large, prominent, pill-shaped
const btnAction = 'inline-flex items-center justify-center rounded-full bg-primary px-8 py-3.5 text-base font-semibold text-white shadow-base transition-all hover:bg-primary-dark'

const modalContainer = "flex justify-center items-center bg-black p-8 fixed top-0 left-0 h-screen w-screen bg-opacity-50 backdrop-blur-sm z-[99]";
const loaderContainer = "flex justify-center items-center fixed top-0 left-0 h-screen w-screen bg-neutral-900/10 backdrop-blur-xs z-[1000]"

const textAreaStyle = 'border rounded-lg h-32 w-full mx-2 border-neutral-300 outline-none p-3 text-neutral-700 font-medium focus:border-primary focus:ring-2 focus:ring-primary-light transition-all';
const smallTextAreaStyle = 'border rounded-lg h-12 w-full mx-2 border-neutral-300 outline-none p-3 text-neutral-700 font-medium focus:border-primary focus:ring-2 focus:ring-primary-light transition-all';
const optionStyle = 'bg-neutral-100 text-primary py-2';
const tableStyle = 'table-auto w-full';
const tableHeader = 'px-4 py-3 bg-neutral-50 text-sm font-semibold text-primary border-b border-neutral-200';
const tableData = 'px-4 py-4 text-left text-sm text-neutral-600 border-b border-neutral-200';
const tableCol = "border-b border-neutral-200 text-sm p-4 text-neutral-600";

const dropDownStyle = {
    multiselectContainer: { 
        maxWidth: '16rem',
        width: '16rem',
        maxHeight: '8rem',
        border: '1px solid #D1D5DB',
        borderRadius: '0.5rem',
        backgroundColor: '#FFFFFF',
    },
    inputField: { 
        fontWeight: '500',
        color: '#1F2937',
    },
    option: {
        backgroundColor: '#F3F4F6',
        color: '#27AE60',
        hover: {
            backgroundColor: '#D5F4E6',
            color: '#1E8449'
        }
    }
};

export { 
    label,
    inputStyle, 
    textAreaStyle, 
    optionStyle, 
    tableStyle, 
    tableHeader, 
    tableData,
    tableCol, 
    smallTextAreaStyle, 
    dropDownStyle,
    btnOne,
    btnOneLight, 
    btnTwo,
    btnSmall,
    btnSmallTwo,
    btnCancel,
    btnRound,
    btnWhite,
    title,
    pageTitle,
    sectionTitle,
    modalTitle,
    modalContainer, 
    loaderContainer,
    btnRed,
    btnGreen,
    btnAction,
    subTitle,
    btnOneNoWidth
};